import { ReactComponent as StarSvg } from "@/assets/icons/star.svg";

const Stars = ({ size }: { size: number }) => (
    <div className="flex items-center gap-1">
        {Array.from({ length: 5 }, (_, i) => (
            <StarSvg key={i} width={size} height={size} />
        ))}
    </div>
);

export default Stars;
